import React from 'react'

import Button from 'app/elements/Button'

import { title, subtitle, button } from './data.json'
import { Container, Title, Subtitle, ButtonContainer } from './styles'

const Advertise = () => (
  <Container>
    <header>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
    </header>
    <ButtonContainer>
      <Button text={button} />
    </ButtonContainer>
  </Container>
)

export default Advertise



// WEBPACK FOOTER //
// ./src/app/pages/ec/DashboardResume/advertise/index.js